import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { SvgIconModule } from '../../components';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { OfflineModule } from '../../offline';

import { VideoPlayerComponent } from './video-player.component';
import { MotesMediaPlayerService } from '../media-player.service';
import { PinchZoomModule } from '@mtnair/ngx-pinch-zoom';

@NgModule({
    declarations: [
        VideoPlayerComponent,
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        MotePipesModule,
        OfflineModule,
        PinchZoomModule,
    ],
    exports: [
        VideoPlayerComponent
    ]
})
export class VideoPlayerModule {
    // Ensure that only one instance of mediaPlayer service is instantiated
    static forRoot(): ModuleWithProviders<VideoPlayerModule> {
        return {
            ngModule: VideoPlayerModule,
            providers: [
                MotesMediaPlayerService
            ]
        };
    }
}
